export default __webpack_public_path__ + "../staticImages/winefinder-sprite-Wein_Schaumwein.png";